import { useState } from 'react';

import { useQuery, gql } from '@apollo/client';

export const GET_INTERVIEW_TYPES = gql`
  query getInterviewTypes($queryOptions: QueryOptionsInput) {
    getInterviewTypes(queryOptions: $queryOptions) {
      collection {
        _id
        name
        fieldsHeadlines
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetInterviewTypes = () => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();

  const pageSize = 12;

  const { data, loading } = useQuery(GET_INTERVIEW_TYPES, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getInterviewTypes || {};

  return {
    interviewTypes: collection,
    totalCount,
    loading,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};

export const useGetAllInterviewTypes = () => {
  const { data } = useQuery(GET_INTERVIEW_TYPES, { fetchPolicy: 'network-only' });

  const { collection = [] } = data?.getInterviewTypes || {};

  return { interviewTypes: collection };
};
